import React, { useEffect, useState, useContext } from "react";
import { useAlert } from 'react-alert';
import { UserContext } from "../../../UserContext";

import CenteredPageContainer from "../../components/layout_components/CenteredPageContainer";
import CardLayout from "../../components/layout_components/CardLayout";
import { TextInput, SelectInput } from "../../components/common_components/Forms";
import Button from "../../components/common_components/Button";


// API Calls
import UserDemographicAPI from "../../api/api_calls/UserDemographicAPI";


function ExtendedProfile(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();

    // Form data
    const [formData, setFormData] = useState({
        country: "",
        age: "",
        education: "",
        industry: "",
        income: "",
        gender: "",
        birth_year: "",
        bio: "",
        job_title: "",
    });

    // Available options
    const [availableOptions, setAvailableOptions] = useState({
        country: [],
        education: [],
        industry: [],
        income: [],
        gender: [],
        birth_year: [],
    });

    // Errors
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);

    // Fetch demographics
    useEffect(() => {
        async function fetchDemographics() {
            try {
                const response = await UserDemographicAPI.show();
                if (response.success) {
                    // console.log(response);
                    setFormData(response.user_demographic);
                    setAvailableOptions(response.available);
                    setLoading(false);
                }
            } catch (error) {
                alert.show("Failed to load demographics", { type: 'error' });
            }
        }

        fetchDemographics();
        document.title = 'Extended Profile | Despark';
    }, []);

    // Handle form change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    // Handle submit
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevents page reload
        setErrors({}); // Clear previous errors

        console.log(formData);

        // If any field is empty ("") , remove it from the form data
        const filteredFormData = Object.fromEntries(
            Object.entries(formData).filter(([_, value]) => value !== "")
        );

        console.log("Form Data: ", filteredFormData);

        // Update password
        try {
            const response = await UserDemographicAPI.update(filteredFormData);

            if (response.success) {
                alert.show("Extended profile updated", { type: 'success' });
                refreshUser();
            } else {
                if (response.error) {
                    alert.show(response.error, { type: 'error' });
                } else {
                    alert.show("Unable to update extended profile", { type: 'error' });
                }
            }
        } catch (error) {
            console.error("Error updating extended profile:", error);
            alert.show("An unexpected error occurred.", { type: 'error' });
        }
    };



    return (
        <CenteredPageContainer>
            <CardLayout>
                <div className="profile-header-container">
                    <h1>Extended Profile</h1>
                    <div className="body-small black-500-text">
                        Your extended profile information not only helps us match you with relevant missions but also maximizes your chances of getting approved for high-value missions.                    </div>
                </div>
                <form className="profile-form" onSubmit={handleSubmit}>
                    <TextInput
                        label="Short bio (optional)"
                        name="bio"
                        value={formData.bio}
                        placeholder="e.g. I'm a memecoin trader and NFT collector."
                        onChange={handleChange}
                        error={errors.bio}
                        type="text"
                    // rows={3}
                    />
                    <div className="extended-profile-form-row">
                        <SelectInput
                            label="Gender"
                            name="gender"
                            value={formData.gender}
                            placeholder="Select your gender"
                            onChange={handleChange}
                            error={errors.gender}
                            options={availableOptions.gender.map(({ id, name }) => ({ value: id, label: name }))}
                        />
                        <SelectInput
                            label="Birth year"
                            name="birth_year"
                            value={formData.birth_year || ""}
                            placeholder="Select your birth year"
                            onChange={handleChange}
                            error={errors.birth_year}
                            options={availableOptions.birth_year.map(({ id, level }) => ({ value: id, label: level }))}
                        />
                    </div>
                    <div className="extended-profile-form-row">
                        <SelectInput
                            label="Annual income"
                            name="income"
                            value={formData.income || ""}
                            placeholder="Select your annual income"
                            onChange={handleChange}
                            error={errors.annual_income}
                            options={availableOptions.income.map(({ id, level }) => ({ value: id, label: level }))}
                        />
                        <SelectInput
                            label="Education"
                            name="education"
                            value={formData.education || ""}
                            options={availableOptions.education.map(({ id, level }) => ({ value: id, label: level }))}
                            // value={formData.highest_level_of_education}
                            placeholder="Select your highest level of education"
                            onChange={handleChange}
                            error={errors.highest_level_of_education}
                        />
                    </div>
                    <TextInput
                        label="Job title"
                        name="job_title"
                        value={formData.job_title}
                        placeholder="e.g. Software Engineer"
                        onChange={handleChange}
                        error={errors.job_title}
                        type="text"
                    />
                    <SelectInput
                        label="Industry"
                        name="industry"
                        value={formData.industry || ""}
                        placeholder="Select your industry"
                        onChange={handleChange}
                        error={errors.industry}
                        options={availableOptions.industry.map(({ id, name }) => ({ value: id, label: name }))}
                    />

                    <Button type="submit">Submit</Button>
                </form>
            </CardLayout>
        </CenteredPageContainer>
    )
}


export default ExtendedProfile